import { FaqItem } from "@/components/landing/faq-item";

const faqItems = [
  {
    question: "Is it free to create an account on VacWork?",
    answer:
      "Yes, creating an account on VacWork is completely free for job seekers. You can create a profile, search for jobs, and apply to positions at no cost. Employers have various subscription options to post jobs and access candidate information.",
  },
  {
    question: "How do I apply for jobs on VacWork?",
    answer:
      "After creating your account and completing your profile, you can browse job listings and apply directly through our platform. Some positions may redirect you to the employer's website to complete the application process.",
  },
  {
    question: "What information should I include in my profile?",
    answer:
      "We recommend including your work experience, education, skills, and a professional summary. The more complete your profile, the better your chances of matching with relevant opportunities. You can also upload your resume for employers to view.",
  },
  {
    question: "How much does it cost for employers to post jobs?",
    answer:
      "We offer several pricing tiers for employers, starting with a basic plan that allows for a limited number of job postings per month. Premium plans include additional features such as featured listings, advanced candidate filtering, and analytics. Contact our sales team for specific pricing information.",
  },
  {
    question: "Can I search for remote jobs on VacWork?",
    answer:
      "Yes, our platform includes filters for remote, hybrid, and in-person positions. You can easily search for remote opportunities that match your skills and experience, regardless of your location.",
  },
  {
    question: "How does VacWork verify employers and job listings?",
    answer:
      "We have a verification process for employers to ensure the legitimacy of companies and job postings on our platform. This includes business registration checks and monitoring of posting activity. We also encourage users to report any suspicious listings.",
  },
];

export function FAQSection() {
  return (
    <section
      className="border-border/50 border-t py-16 md:py-20 lg:py-24"
      id="faq"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 md:px-8">
        <div className="mb-12 flex flex-col items-center justify-center space-y-4 text-center md:mb-16 md:space-y-6 lg:mb-20">
          <h2 className="font-light text-2xl leading-tight tracking-tight sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
            Frequently asked questions
          </h2>
          <p className="max-w-3xl text-left font-light text-base text-muted-foreground leading-relaxed sm:text-lg md:text-xl">
            Find answers to common questions about using VacWork
          </p>
        </div>
        <section className="w-full py-16">
          <div className="container">
            {/* FAQ Items */}
            <div className="mx-auto max-w-2xl space-y-2">
              {faqItems.map((item, index) => (
                <FaqItem
                  answer={item.answer}
                  index={index}
                  key={item.question}
                  question={item.question}
                />
              ))}
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}
